import styled from "styled-components"

export const Results = styled.div`
  margin-top: 28px;
  position: absolute;
  max-height: 200px;
  overflow: scroll;
  border: 1px solid #888;
  z-index: 10;
`